import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';
import { AbstractService } from '../../services/abstract.service';
import { ReviewService } from '../../services/review.service';

//  Libraries
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { NotificationsService } from 'angular2-notifications';
declare var $: any;
import * as moment from 'moment';

export class ReviewModalWindow extends BSModalContext {
    public id: string;
}

@Component({
    selector: 'create-review-component',
    templateUrl: './createReview.component.html',
    providers: []
})

export class CreateReviewComponent implements ModalComponent<ReviewModalWindow>, OnInit {

    modalContext: ReviewModalWindow;
    review: any = {};
    ratings: any = [
        {
            value: 1
        },
        {
            value: 2
        },
        {
            value: 3
        },
        {
            value: 4
        },
        {
            value: 5
        }
    ];

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private abstractService: AbstractService,
        private reviewService: ReviewService,
        private notificationService: NotificationsService,
        public dialog: DialogRef<ReviewModalWindow>) {

        this.modalContext = dialog.context;
        this.modalContext.dialogClass = 'modal-side-bar side-bar-wide';
    }

    ngOnInit() {

        this.reviewService.getReview(this.modalContext.id)
            .subscribe(review => {
                this.review = review;
                this.buildCriteriaNodes(review.criteria);
            }, err => {
                console.log(err);
            });
    }

    buildCriteriaNodes(criterias: any) {
        for (let criteria of criterias) {
            for (let node of criteria.nodes) {
                var scoreIndex = this.review.scores.findIndex(s => s.criterion == node.id);

                node.score = this.review.scores[scoreIndex];
            }
        }
    }

    updateReview(criteriaId: number, nodeId: number, rating: number) {

        var scoreIndex = this.review.scores.findIndex(s => s.criterion == nodeId);

        this.review.scores[scoreIndex].criterion = criteriaId;
        this.review.scores[scoreIndex].score = rating;
         
        this.reviewService.updateReview(this.review.id, nodeId, rating)
            .subscribe(response => {
                
                this.review = response;
                this.buildCriteriaNodes(this.review.criteria);
                this.notificationService.info('Review Saved', 'Your rating has been successfully saved', null);
                this.reviewService.emitReviewerEvent('update', this.review);
            }, err => {
                this.notificationService.error('Review Not Saved', 'Your rating was not saved', null);
            });
    }

    createDate(date: string) : Date {
        return new Date(date);
    }

    close() {
        this.dialog.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/createReview.component.ts